export const format_number_as_currency = number => {
    return `${!!number ? `$${ADV.util.number_format(number, 0)}` : '–'}`
}